import {
    actionsInNotificationEventGroup,
    knownNotificationEventActions,
} from '../notification-event-presentation.js';

export const NOTIFICATION_PAGE_SIZE = 20;
export const NOTIFICATION_LIST_PAGE_SIZE = 15;

/**
 * Maps an inbox action-group facet to suffix lists the API already understands.
 * Messenger stays free of GRC ACTION_META — the web catalog owns the grouping.
 */
export function inboxEventActionParams(eventGroup) {
    if (!eventGroup) return {};
    if (eventGroup === 'other') {
        return { excludeEventActions: knownNotificationEventActions().join(',') };
    }
    const actions = actionsInNotificationEventGroup(eventGroup);
    return actions.length ? { eventActions: actions.join(',') } : {};
}

/**
 * Query object for GET /notification/my/all.
 * Mirrors the previous fetch URLSearchParams rules (omit includeUniqueValues when false).
 */
export function buildNotificationInboxQuery(
    pageOrParams = 1,
    limit = NOTIFICATION_PAGE_SIZE,
    unreadOnly = false,
) {
    const params =
        typeof pageOrParams === "object" && pageOrParams !== null
            ? pageOrParams
            : { page: pageOrParams, limit, unreadOnly };

    const query = {
        page: params.page ?? 1,
        limit: params.limit ?? params.pageSize ?? NOTIFICATION_PAGE_SIZE,
    };
    if (params.unreadOnly) query.unreadOnly = true;
    if (params.read) query.read = String(params.read);
    if (params.search) query.search = String(params.search);
    if (params.sortBy) query.sortBy = String(params.sortBy);
    if (params.sortOrder) query.sortOrder = String(params.sortOrder);
    if (params.type) query.type = String(params.type);
    if (params.eventActions) query.eventActions = String(params.eventActions);
    if (params.excludeEventActions) query.excludeEventActions = String(params.excludeEventActions);
    if (params.includeUniqueValues !== false) query.includeUniqueValues = true;
    return query;
}
